import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    ...appConfig.providers,
    provideAnimations(), 
    provideToastr({
      timeOut: 3000, 
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  ]
}).catch((err) => console.error(err));
